import styled from 'styled-components'

import Container from '@/common/components/Container'
import Image from '@/common/components/Image'
import { media } from '@/common/utils/viewport'

export const StyledContainer = styled(Container).attrs({
  className: 'mx-auto mt-48 mb-100 mt-40-mobile mb-64-mobile',
})`
  max-width: 720px;

  ${media.down('sm')`
    max-width: unset;
  `}
`

export const StyledImage = styled(Image).attrs({
  className: 'mt-16 mb-28',
})`
  max-width: 100%;
`
